module.exports = __webpack_public_path__ + "static/media/dog-large.4654ff7a.svg";